// AddToCollectionModal.js - Legacy wrapper using consolidated CollectionModal
import CollectionModal from './CollectionModal';

const AddToCollectionModal = props => <CollectionModal mode="collection" {...props} />;

export default AddToCollectionModal;
